export const getCssProperty = (property: string) => {
  const style = window.getComputedStyle(document.documentElement)
  return style.getPropertyValue(property)
}
